import { __ } from '@wordpress/i18n'

export default { notFound: __('No jobss', 'dhsv_theme') }
